import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import PatientRegister from '@/views/PatientRegister.vue'
import PatientEMR from '@/views/PatientEMR.vue'
import LoginHOSxP from '@/views/LoginHOSxP.vue'
import Profile from '@/views/Profile.vue'
import LabBTR from '@/views/Labs/LabBTR.vue'
import RoundWard from '@/views/IPDs/RoundWard.vue'
import FilesScan from '@/views/FilesScan/FilesScan.vue'
import eFormSettings from '@/views/eFormSettings.vue'


import EverReferToHOSxP from '@/views/EverReferToHOSxP/EverReferToHOSxP.vue'


import store from '@/store/store'
// import About from '@/views/about.vue'

Vue.use(VueRouter)

export default new VueRouter({
	mode: 'history',
	base: process.env.NODE_ENV === 'production' ? '/' : '/',
	linkActiveClass: 'active',
	routes: [
		{
			path: '/LoginHOSxP/:com?',
			name: 'LoginHOSxP',
			component: LoginHOSxP
		},
		{
			path: '/PatientEMR/:hn?/:vn?',
			name: 'PatientEMR',
			component: PatientEMR
		},
		{
			path: '/PatientRegister',
			name: 'PatientRegister',
			component: PatientRegister
		},
		{
			path: '/files-scan',
			name: 'files-scan',
			component: FilesScan
		},
		{
			path: '/btr-cross-matching',
			name: 'btr-cross-matching',
			component: LabBTR
		},
		{
			path: '/round-ward',
			name: 'round-ward',
			component: RoundWard
		},
		{
			path: '/profile',
			name: 'profile',
			component: Profile
		},
		{
			path: '/index.html',
			component: Home,
			alias: '/'
		},

		{
			path: '/ever-refer-to-hosxp/:tabs?/:pages?',
			name: 'ever-refer-to-hosxp',
			component: EverReferToHOSxP
		},

		{
			path: '/e-form-settings',
			name: 'e-form-settings',
			component: eFormSettings
		},

		{
			path: '/',
			name: 'home',
			component: Home
		}
		// {
		//   path: '/about',
		//   name: 'about',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		//   component: () => import(/* webpackChunkName: "about"  '../views/About.vue')
		// },
	]
})

/*
const routes = [
  {
    path: '/PatientEMR/:hn?/:vn?',
    name: 'PatientEMR2',
    component: PatientEMR
  },
  {
    path: '/PatientRegister',
    name: 'PatientRegister',
    component: PatientRegister,
  },
  {
    path: '/',
    name: 'home',
    component: Home
  },
]

const router = new VueRouter({ mode: 'history', linkActiveClass: "active", routes: routes })
/*
router.beforeResolve((to, from, next) => {
  if (to.name) {
    console.log('aaaaaaaaaa')
  }
  next()
})

router.afterEach((to, from) => {
  console.log('bbbbbbbbbb')
})
*/
/*
export default router
*/
